import { http } from "../../../axios";
class citizenService {
  menu(payload: any) {
    return http().post(`user/menu`, payload);
  }
  getCitizenList(payload:any){
    return http().post(`user/citizen`,payload);
  }
  getInvitCitizenList(payload:any){
    return http().post(`planet/citizens_list`,payload);
  }
  
  inviteCitizen(payload: any) {
    return http().post(`planet/add/citizen`, payload);
}

adminList(payload: any) {
  return http().post(`user/admin_stuff`, payload);
}

likeCount(payload: any) {
  return http().post(`user/like_count`, payload);
}

engageCount(payload: any) {
  return http().post(`user/engage_count`, payload);
}

citizenStatus(payload: any) {
  return http().post(`user/status`, payload);
}
citizenAdd(payload: any) {
  return http().post(`user/naturalized`, payload);
}

}

export default new citizenService();